import styled from 'styled-components';
import {
  InsurerStyled,
  InsurerStyledHeaderTitle
} from 'app/Components/common/Insurer/styles';

export const GeneralSettingsStyled = styled(InsurerStyled)``;

export const GeneralSettingsStyledSection = styled.div`
    &:not(:last-child) {
        margin-bottom: 8px;
        border-bottom: 1px solid ${({ theme }) => theme.colors.strokeB};
    }
`;

export const GeneralSettingsStyledSectionHeader = styled.h3`
    font-family: '${({ theme }) => theme.font.medium}';
    font-size: 20px;
    margin-bottom: 4px;
`;

export const GeneralSettingsStyledHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 8px;
    .qmt-ui-input,
    .qmt-ui-input--active {
        height: 46px;
        flex: 1;
    }
`;

export const GeneralSettingsStyledControls = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const GeneralSettingsStyledHeaderTitle = styled(InsurerStyledHeaderTitle)``;
